import Container from "@/components/Container";
import RecommendedWrapper from "@/components/Recommended/RecommendedWrapper";
import PodcastTiles from "@/containers/PodcastTiles";
import { apiPath } from "@/helpers/apiPath";
import useRequest from "@/helpers/useRequest";

import styles from "../EmptyState.module.scss";

const SuggestedPodcasts = () => {
  const { data: podcasts } = useRequest(
    apiPath.PODCASTS({ page: 1, perPage: 6 })
  );

  return (
    <RecommendedWrapper title="Popularne" className={styles.heading}>
      <Container className={styles.podcastsContainer}>
        <PodcastTiles items={podcasts?.items || []} />
      </Container>
    </RecommendedWrapper>
  );
};

export default SuggestedPodcasts;
